@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.edit-shopper-canvas {
  background-color: var(--white);
}

.drawer-header-title {
  align-self: flex-start;
  font-size: 16px;
}
